import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, className = "", delay = 0, ...props }) => {
  const reduced = useReducedMotion();
  return <motion.div initial={reduced ? false : { opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }} transition={{ duration: reduced ? 0 : 0.55, delay: reduced ? 0 : delay, ease: [0.22, 1, 0.36, 1] }}
    className={className} {...props}>{children}</motion.div>;
};